// src/features/auth/applications/createRiderIfMissing.js
import Storage from '@/shared/utils/storage.js'
import { API_BASE_URL, getUserId } from '@/project/data/config/apiConfig.js'

/**
 * Crée le profil rider sur l'API si le riderId est absent du userData.
 * Ensuite, met à jour le user pour stocker le riderId dans ses metadata.
 * Retourne le riderId (qu'il ait été créé ou déjà existant).
 */
async function createRiderIfMissing(context) {
  const userData = Storage.get('userData')
  const userId = userData?.id || getUserId()

  if (!userId) {
    console.warn('[createRiderIfMissing] Aucun userId disponible, skip.')
    return null
  }

  // Vérifier si le riderId est déjà présent (dans metadata ou dans storage direct)
  const existingRiderId = Storage.get('riderId') || userData?.metadata?.riderId
  if (existingRiderId) {
    console.log('[createRiderIfMissing] riderId déjà présent:', existingRiderId)
    return existingRiderId
  }

  console.log('[createRiderIfMissing] Aucun riderId trouvé, création du rider...')

  try {
    // 1. Créer le rider via POST /rider/add
    const kycId = `kyc_rider_${userId}`
    const walletId = userData?.metadata?.walletId || `wallet_${userId}`

    const createRes = await fetch(
      `${API_BASE_URL}/rider/add?group=ultraxeno`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(userData?.token ? { Authorization: `Bearer ${userData.token}` } : {}),
        },
        body: JSON.stringify({
          userId,
          kycId,
          walletId,
          vehicleType: userData?.metadata?.vehicleType || userData?.vehicleType || 'motorcycle',
          vehiclePlate: userData?.metadata?.vehiclePlate || userData?.vehiclePlate || '',
          city: userData?.metadata?.city || userData?.city || 'Cotonou',
        }),
      },
    )

    const createData = await createRes.json()
    console.log('[createRiderIfMissing] Réponse création rider:', createData)

    // 201 = créé, 200 = déjà existant ou retrouvé
    const riderId = createData?.data?.id
    if (!riderId) {
      console.warn('[createRiderIfMissing] Rider non créé (peut-être KYC non approuvé):', createData?.message)
      return null
    }

    console.log('[createRiderIfMissing] Rider créé avec succès, riderId:', riderId)

    // 2. Mettre à jour le user pour persister le riderId dans ses metadata (seule source de vérité)
    const updateRes = await fetch(
      `${API_BASE_URL}/user/rapidoo-rider/update?group=ultraxeno`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(userData?.token ? { Authorization: `Bearer ${userData.token}` } : {}),
        },
        body: JSON.stringify({
          email: userData?.email,
          metadata: {
            riderId,
          },
        }),
      },
    )

    const updateData = await updateRes.json()
    console.log('[createRiderIfMissing] User mis à jour avec riderId:', updateData)

    // 3. Mettre à jour le userData local (en mémoire uniquement, pas de clé riderId séparée)
    // Le riderId est accessible via userData.metadata.riderId
    const updatedUserData = {
      ...userData,
      metadata: {
        ...(userData?.metadata || {}),
        riderId,
      },
    }
    Storage.save('userData', updatedUserData)

    return riderId
  } catch (error) {
    console.error('[createRiderIfMissing] Erreur lors de la création du rider:', error)
    return null
  }
}

export default createRiderIfMissing
